import restAPI from '@/utils/rest-api'

export default {
    getTimeFrames() {
        return restAPI.get(encodeURI('/time-frames'))
    },
    potentialCustomerSubmit(data) {
        return restAPI.post(encodeURI('/potential-customers'), data)
    },
    phoneExists(phone) {
        return restAPI.get(encodeURI(`/potential-customers/is-unique/mobile/${phone}`))
    }

}
